module.exports = __webpack_public_path__ + "images/externallinkicon1.svg";